import { render, staticRenderFns } from "./StudentSubjectsStatusTable.vue?vue&type=template&id=4af55509"
import script from "./StudentSubjectsStatusTable.vue?vue&type=script&lang=js"
export * from "./StudentSubjectsStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports